import { AType } from "@silversea-ssc/functional-support"
import { NonEmptyString as IoTsNonEmptyString } from "io-ts-types"
import { brandString } from "./brand-string"

//TODO once NonEmptyStringV2 is used in the codebase:
// 1. make NonEmptyString private
// 2. derive the type from NonEmptyStringV2
// 3. remove NonEmptyString
export const NonEmptyString = /* @__PURE__ */ brandString(IoTsNonEmptyString, ({ string }) => string({ minLength: 1 }))
export type NonEmptyString = AType<typeof NonEmptyString>
